import { Link } from 'react-router-dom';
import { LuChevronRight } from 'react-icons/lu';
import type { IconType } from 'react-icons';

import SbrIcon from './SbrIcon';

export type RoleLinkCardItem = {
  title: string;
  subtitle?: string;
  Icon: IconType;
};

type RoleLinkCardProps = {
  item: RoleLinkCardItem;
  to?: string;
  /** Light cards on white; dark cards on navy sections (Home roles, RWF industries band). */
  variant?: 'light' | 'dark';
  /** Horizontal bar (default) or narrow stacked tile for Home grids. */
  layout?: 'horizontal' | 'stacked';
  className?: string;
};

/** Role/category link tile with teal pop on hover — shared across site. */
export default function RoleLinkCard({
  item,
  to = '/book-a-call',
  variant = 'light',
  layout = 'horizontal',
  className = '',
}: RoleLinkCardProps) {
  const variantClass = variant === 'dark' ? 'sbr-role-link-card--on-dark' : '';
  const layoutClass = layout === 'stacked' ? 'sbr-role-link-card--stacked' : '';
  const stacked = layout === 'stacked';

  return (
    <Link
      className={['sbr-role-link-card', variantClass, layoutClass, className].filter(Boolean).join(' ')}
      to={to}
    >
      <span className="sbr-role-link-card__icon" aria-hidden>
        <SbrIcon icon={item.Icon} size={stacked ? 24 : 22} />
      </span>
      <span className="sbr-role-link-card__copy">
        <span className="sbr-role-link-card__title">{item.title}</span>
        {item.subtitle ? <span className="sbr-role-link-card__subtitle">{item.subtitle}</span> : null}
      </span>
      {!stacked ? (
        <SbrIcon icon={LuChevronRight} size={18} className="sbr-role-link-card__chevron" aria-hidden />
      ) : null}
    </Link>
  );
}
